export default __webpack_public_path__ + "static/media/chain_swap.6974ae64.svg";